module.exports = __webpack_public_path__ + "media/dial_tone.9e5e0a64.mp3";